import React from 'react';
import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';
import OperationListItem from '../operations/OperationListItem';
import { onSortColumn } from 'src/utils/stowage/operationListSortUtils';
import { SortStowageColumnEnum } from 'src/enums/stowage/sortStowageColumnEnum';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';

export interface TransitOperationsListProps {
    operations: RotationCargoOperation[];
    operationListSortColumn: SortStowageColumnEnum;
    isOperationListSortDesc: boolean;
    activeStowagePlan: StowagePlan;
}

const OperationListTransitOperationsComponent: React.FC<TransitOperationsListProps> = ({
    operations,
    operationListSortColumn,
    isOperationListSortDesc,
    activeStowagePlan,
}) => (
    <>
        <span className="transit-op">Transit operations in port call</span>
        {operations
            .sort((a, b) => onSortColumn(operationListSortColumn, isOperationListSortDesc, a, b, activeStowagePlan))
            .map((op) => (
                <OperationListItem cargoOperation={op} key={'transit-op-' + op.cargoOperationGuid} />
            ))}
    </>
);

export default OperationListTransitOperationsComponent;
